import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { CircularProgress } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';

import { getRequest } from 'utils/api';
import { formatPrice } from 'utils/helpers';
import ArrowGrowGreen from 'public/icons/arrow-grow-green.svg';
import styles from 'styles/components/profile/AnalyticsCard.module.scss';

const marginTop = { marginTop: 15 };

const EarningsCard = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const totalEarnings = data.total_earnings || 0;

  useEffect(() => {
    setIsLoading(true);

    getRequest({ endpoint: 'profiles/analytics', query: { date_filter: 'this_year' } })
      .then(response => {
        setData(response);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  if (isLoading && (isEmpty(data) || !data))
    return (
      <div className={styles.card}>
        <CircularProgress color="primary" style={marginTop} />
      </div>
    );

  return (
    <Link href="/earnings" passHref>
      <div className={styles.card}>
        <div className={styles.whiteCircle}>
          <ArrowGrowGreen width={40} height={40} />
        </div>

        <div className={styles.content}>
          <h3>This year's earnings</h3>

          <div className={styles.earnings}>{formatPrice(totalEarnings)}</div>

          <small
            style={{ position: 'absolute', right: 15, bottom: 11, fontSize: 12 }}
            className="color-main"
          >
            View Earnings
          </small>
        </div>
      </div>
    </Link>
  );
};

export default EarningsCard;
